<template lang="pug">
  .flex-start.gap-1(v-tooltip.top="showTooltip ? tooltipText(camelizedUser) : ''")
    Avatar(
      shape="square"
      :image="camelizedUser?.avatarUrl"
      :size="props.size"
      :class="cssClass"
    )

    span(v-if="showInitials") {{ user.initials }}

    //- pre props.size: {{ props.size }}
    //- pre cssClass: {{ cssClass }}
</template>

<script setup>
  import { computed } from 'vue'
  import { utils } from '@/utils'

  const props = defineProps({
    user:        { type: Object, required: true, default: {} },
    size:        { type: String, default: 'normal' },
    showTooltip: { type: Boolean, default: false },
    showInitials: { type: Boolean, default: false },
  })

  const cssClass = computed(() => {
    const strArr = []
    switch (props.size) {
      case 'mini':
        strArr.push('p-avatar-mini')
        break
      case 'small':
        strArr.push('p-avatar-small')
        break
      case '2xl':
        strArr.push('p-avatar-2xl')
        break
      case '3xl':
        strArr.push('p-avatar-3xl')
        break
      case 'expand':
        strArr.push('p-avatar-expand')
        break
    }

    return strArr.join(' ')
  })

  function tooltipText(u) {
    return `(${u.initials}) ${u.fullName}`
  }

  const camelizedUser = computed(() => utils.camelizeKeysDeep(props.user))
</script>
